export const linkToNotFound = () => `/app/not-found`;
